import { useEffect, type FC } from "react";

import { useNavigate } from "react-router-dom";

import "./NotFound.scss";

export const NotFound: FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      navigate("/events");
    }, 2500);
  }, []);

  return (
    <div className="not-found-container">
      <div className="not-found">
        <h1>404</h1>
        <img src="not-found.png" alt="" />
      </div>
      <p>
        אופסי... נראה שהעמוד שניסתם להגיע אליו בשיפוצים, כבר תועברו לעמוד אחר
      </p>
    </div>
  );
};
